"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LANG_LT_TRANS = {
    'time picker': 'Laiko pasirinkimas',
    'today': 'Šiandien',
    'set time': 'Nustatyti laiką',
    'close': 'Uždaryti',
    'confirm': 'Patvirtinti',
    'hour': 'Valanda',
    'minute': 'Minutė',
    'second': 'Sekudnė',
};
//# sourceMappingURL=lt.js.map


//////////////////
// WEBPACK FOOTER
// /opt/app/develop/~/ng2-date-time-picker/locale/lt.js
// module id = ../../../../ng2-date-time-picker/locale/lt.js
// module chunks = 4